class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);

/* ------------------------------------------------------------------
   Kleine Anpassungen, die eigentlich in Liquid gehoeren.
   Sie stehen hier, weil footer.liquid (41 KB), theme.liquid (27 KB),
   snippets/cart-drawer.liquid (28 KB) und sections/main-product.liquid
   (182 KB) zu gross sind, um sie fuer eine Kleinigkeit komplett neu zu
   uebertragen. Diese Datei wird auf jeder Seite geladen und war klein genug.
   Original ohne diesen Block liegt unter
   X:\03 Werbung\cloud\theme-sicherung\details-disclosure-vor-2026-08-20.js
   ------------------------------------------------------------------ */
(function () {
  /* Die Icon-Liste aus der Fusszeile ist die Vorlage fuer alle Stellen:
     sie zeigt die tatsaechlich aktiven Zahlungsarten, aktuell acht. */
  function zahlungsiconsKopieren() {
    var quelle = document.querySelector('.footer__payment .list-payment');
    if (!quelle) return null;
    var kopie = quelle.cloneNode(true);
    kopie.removeAttribute('id');
    kopie.style.margin = '0';
    kopie.style.flexWrap = 'wrap';
    return kopie;
  }

  /* 20.08.2026: Widerrufsbutton in einem neuen Tab oeffnen.
     Shopify-Menueeintraege koennen kein target setzen. */
  function widerrufLinksAufNeuenTab() {
    document.querySelectorAll('a[href*="connect.haendlerbund"]').forEach(function (link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }

  /* 01.09.2026: Verweise auf fremde Websites in der Fusszeile in einem neuen
     Tab oeffnen. Aufgefallen bei Erics Test des Shops: kpc-dresden.de und
     bierbomb.com ersetzten den Shop im selben Tab, der Besucher war weg.
     Shopify-Menueeintraege koennen kein target setzen, deshalb hier.
     Nur die Fusszeile, und nur echte Fremdziele: tel:, mailto: und Links auf
     mokross.shop selbst bleiben unberuehrt. Die Schreibweise mit und ohne
     www zaehlt als dieselbe Seite - sonst wuerde der Shop sich selbst in
     einem neuen Tab oeffnen. */
  function eigeneSeite(host) {
    return host.replace(/^www\./, '') === location.hostname.replace(/^www\./, '');
  }

  function fremdeLinksAufNeuenTab() {
    var bereiche = document.querySelectorAll('footer, .footer, #shopify-section-footer');
    Array.prototype.forEach.call(bereiche, function (bereich) {
      Array.prototype.forEach.call(bereich.querySelectorAll('a[href]'), function (link) {
        if (link.getAttribute('target')) return;
        var url;
        try {
          url = new URL(link.href, location.href);
        } catch (e) {
          return;
        }
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
        if (eigeneSeite(url.hostname)) return;
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
    });
  }

  /* 20.08.2026: Zahlungsicons unter dem Warenkorb-Button der Produktseite.
     Das Theme legt den Container .methods_of_payment an, befuellt ihn aber
     nicht. */
  function zahlungsiconsProduktseite() {
    var ziel = document.querySelector('.product__info-container .methods_of_payment');
    if (!ziel || ziel.children.length > 0) return;

    var kopie = zahlungsiconsKopieren();
    if (!kopie) return;

    ziel.style.marginTop = '1.5rem';
    ziel.appendChild(kopie);
  }

  /* 20.08.2026: Warenkorb-Schublade. Dort standen nur sechs Icons statt acht.
     Reihenfolge auf Wunsch von Enrico: erst der Auschecken-Button, darunter
     die Icons - also die urspruengliche Anordnung des Themes. */
  function zahlungsiconsSchublade() {
    var ziel = document.querySelector('.cart-drawer .methods_of_payment');
    if (!ziel || ziel.dataset.angepasst === '1') return;

    var kopie = zahlungsiconsKopieren();
    if (!kopie) return;

    ziel.innerHTML = '';
    ziel.appendChild(kopie);
    ziel.style.margin = '1.2rem 0 0';
    ziel.dataset.angepasst = '1';
  }

  /* ------------------------------------------------------------------
     22.08.2026: Microsoft Clarity - aber erst nach Einwilligung.

     Vorgeschichte: Die Clarity-App band sich selbst in den <head> ein und
     sendete bei jedem Besucher, ohne zu fragen. Gemessen am 22.08.2026:
     fuenf Uebertragungen an z.clarity.ms ohne jede Zustimmung.

     Der saubere Weg waere Shopifys Web-Pixel - der prueft die Einwilligung
     von selbst. Er liess sich nicht verbinden: Das alte Clarity-Projekt
     (xyexxhkmjs) gehoerte einem fremden Konto, die App antwortete mit 403.
     Deshalb ein neues Projekt im eigenen Konto: y7pmny7o2i.

     WICHTIG: Die beiden Clarity-App-Embeds im Theme muessen AUS bleiben.
     Sind sie an, laeuft der ungeschuetzte Weg parallel und diese Sperre
     ist wirkungslos. Nachsehen unter Theme-Editor -> App-Einbettungen.
     ------------------------------------------------------------------ */
  var CLARITY_PROJEKT = 'y7pmny7o2i';

  function clarityLaden() {
    if (document.getElementById('clarity-nach-einwilligung')) return;

    /* Erst die Warteschlange, dann das Tag - genau in dieser Reihenfolge.
       Microsofts Vorlage macht das ebenso. Beim ersten Anlauf am 22.08.2026
       hatte ich diesen Stummel weggelassen: Das Tag lud, window.clarity blieb
       leer, und es wurde nichts uebertragen. */
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

    /* 13.10.2026: Seit 31.10.2025 verlangt Clarity im EWR ein Einwilligungssignal, sonst zaehlt jede Seite als eigene Sitzung. Geladen wird nur nach Analyse-Einwilligung, deshalb analytics immer granted. */ var werbungOk = false; try { var cpw = window.Shopify && window.Shopify.customerPrivacy; werbungOk = !!(cpw && typeof cpw.marketingAllowed === 'function' && cpw.marketingAllowed()); } catch (e) {} window.clarity('consentv2', { ad_Storage: werbungOk ? 'granted' : 'denied', analytics_Storage: 'granted' }); var s = document.createElement('script');
    s.id = 'clarity-nach-einwilligung';
    s.async = true;
    s.src = 'https://www.clarity.ms/tag/' + CLARITY_PROJEKT;
    document.head.appendChild(s);
  }

  function analyseErlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function'
                && cp.analyticsProcessingAllowed());
    } catch (e) {
      return false;
    }
  }

  function clarityNurMitEinwilligung() {
    /* Faellt der Besuch auf eine bereits erteilte Zustimmung, sofort laden. */
    if (analyseErlaubt()) clarityLaden();

    /* Entscheidet der Besucher waehrend des Besuchs, ebenfalls nachziehen.
       Das Ereignis liefert Shopify, sobald ein Banner eine Wahl schreibt. */
    document.addEventListener('visitorConsentCollected', function (e) {
      var erlaubt = e && e.detail && e.detail.analyticsAllowed;
      if (erlaubt || analyseErlaubt()) clarityLaden();
    });
  }

  function einwilligungBeobachten() {
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        clarityNurMitEinwilligung();
      });
    } else {
      /* Ohne die Schnittstelle wird nichts geladen - im Zweifel gegen das
         Tracking. Das Ereignis wird trotzdem abgehoert. */
      clarityNurMitEinwilligung();
    }
  }

  function anpassungen() {
    widerrufLinksAufNeuenTab();
    fremdeLinksAufNeuenTab();
    zahlungsiconsProduktseite();
    zahlungsiconsSchublade();
  }

  /* Die Schublade wird bei jeder Warenkorb-Aenderung neu aufgebaut, dabei geht
     unsere Anpassung verloren. Der Beobachter setzt sie neu.
     Die Marke data-angepasst verhindert, dass wir uns selbst im Kreis drehen. */
  function schubladeBeobachten() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(zahlungsiconsSchublade).observe(drawer, { childList: true, subtree: true });
  }

  function start() {
    anpassungen();
    schubladeBeobachten();
    einwilligungBeobachten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
